import orderTranslationsHelper from "../../../../../languages/order-translations.helper";
import {
  OrderCancelRevertRequestOrderCancelNotRequestedError,
  OrderCancelRevertRequestErrorType,
  OrderCancelRevertRequestFinishedError,
  OrderCancelRevertRequestOrderCancelledError,
} from "./order-cancel-revert-request-error";

const createRevertOrderCancelledError =
  (): OrderCancelRevertRequestOrderCancelledError => {
    const translations =
      orderTranslationsHelper.getDetailsTranslations().revertCancelOrderRequest
        .errors;

    return {
      message: translations.orderCancelledError,
      params: {},
      type: OrderCancelRevertRequestErrorType.ORDER_CANCELLED,
    };
  };

const createRevertOrderCancelNotRequestedError =
  (): OrderCancelRevertRequestOrderCancelNotRequestedError => {
    const translations =
      orderTranslationsHelper.getDetailsTranslations().revertCancelOrderRequest
        .errors;

    return {
      message: translations.orderCancelRequestedError,
      params: {},
      type: OrderCancelRevertRequestErrorType.ORDER_CANCEL_NOT_REQUESTED,
    };
  };

const createRevertOrderFinishedError =
  (): OrderCancelRevertRequestFinishedError => {
    const translations =
      orderTranslationsHelper.getDetailsTranslations().revertCancelOrderRequest
        .errors;

    return {
      message: translations.orderFinishedError,
      params: {},
      type: OrderCancelRevertRequestErrorType.ORDER_FINISHED,
    };
  };

const orderCancelRevertRequestErrorFactory = {
  createRevertOrderCancelledError,
  createRevertOrderCancelNotRequestedError,
  createRevertOrderFinishedError,
};

export default orderCancelRevertRequestErrorFactory;
